/* Supercharger – 19grams für Tesla (assets/sc-supercharger.js)
   Hero-Laden mit Blitzen, Zähler, Dual Motor, Flavour-Display, Rezept-Konfigurator, Akku-Anzeige, DE/EN (synchron mit Weglot).
   Geladen wird immer die Bohne oder die Pause, nie die Person (keine Koffein-Claims). */
(function () {
  'use strict';

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NBSP = ' ';

  /* ---------- Texte ---------- */
  var EN = {
    lang_group: 'Language',
    hero_lead: 'Charging break? Perfect. The bean is already plugged in. Press and hold the button to charge it up.',
    hold_label: '<strong>Press and hold</strong> to charge',
    charge_aria: 'Charge the bean: press and hold',
    scroll_hint: 'What’s under the hood?',
    specs_kicker: 'Specs',
    specs_title: 'Specs like a car. Just tastier.',
    spec_time_label: '0 to espresso',
    spec_time_sub: 'That’s the shot time on an espresso machine.',
    spec_range_label: 'cups per kilo',
    spec_range_sub: 'Range at 10 g of beans per cup.',
    spec_ratio_label: 'Gear ratio',
    spec_ratio_sub: '{dose}' + NBSP + 'g of coffee in, {yield}' + NBSP + 'g of espresso out.',
    spec_motor_label: 'Motors',
    spec_motor_sub: '{front} + {rear}, one blend.',
    motor_kicker: 'Under the hood',
    motor_intro: 'Supercharger runs on two motors: two coffees from two countries in one bag. One brings the grip, the other the push.',
    motor_front: 'Motor 1 · front',
    motor_rear: 'Motor 2 · rear',
    lbl_farm: 'Farm', lbl_variety: 'Variety', lbl_process: 'Process', lbl_altitude: 'Altitude', lbl_harvest: 'Harvest',
    proc_washed: '<strong>Washed</strong> means the fruit comes off before drying. That usually tastes clean and clear.',
    proc_natural: '<strong>Natural</strong> means the bean dries inside the whole cherry. That often tastes sweeter and fuller.',
    proc_honey: '<strong>Honey</strong> means some of the fruit stays on while drying. Taste-wise it sits between washed and natural.',
    proc_anaerobic: '<strong>Anaerobic</strong> means the cherries ferment without oxygen. That often brings intense, fruity notes.',
    ota: 'Over-the-air update: when a new harvest comes in, this data updates itself.',
    taste_title: 'What you taste',
    taste_intro: 'Straight from the bag. Tap a note and we’ll translate.',
    build_kicker: 'Configurator',
    build_title: 'Build your Supercharger',
    build_intro: 'Like configuring a car, only faster: drivetrain, model, drive mode. Your recipe shows up below.',
    step_machine: 'Drivetrain', step_drink: 'Model', step_mode: 'Drive mode', step_milk: 'Milk',
    m_auto: 'Bean-to-cup', m_auto_sub: 'Push a button, done',
    m_sieb: 'Espresso machine', m_sieb_sub: 'You’re in control',
    m_moka: 'Moka pot', m_moka_sub: 'Old school, still good',
    mode_chill_sub: 'milder, longer', mode_standard_sub: 'our recipe', mode_sport_sub: 'bolder, shorter',
    milk_dairy: 'Dairy', milk_oat: 'Oat',
    sum_kicker: 'Your build',
    sum_delivery: 'Estimated delivery:',
    sum_range: 'Range per 1 kg bag:',
    share: 'Share recipe',
    label_caption: 'The bag you just scanned.',
    berlin_title: 'Roasted in Berlin. Poured at Tesla.',
    berlin_body: '19grams is a specialty coffee roastery from Berlin. We make really good coffee approachable, no coffee jargon needed. We roast Supercharger for Tesla in Germany.',
    berlin_sign: 'See you at your next charging break.',
    egg_hint: 'Psst: tap the bean up top five times, fast.'
  };

  var T = {
    de: {
      st_charging: 'Lädt …', st_letgo: 'Nicht loslassen! Gleich voll.', st_full: 'Voll geladen. Ready to brew.',
      st_again: 'Schon voll. Mehr geht nicht … oder?', st_over: 'Überladen! 150' + NBSP + '%. Okay, das war zu viel Strom.', st_zap: 'Bzzzt.',
      hud: 'Ladestand {p}', hud_full: 'Voll geladen',
      share_copied: 'Link kopiert.', share_fail: 'Hier ist dein Link: {url}', share_text: 'Mein Supercharger-Build: {title}',
      m_auto: 'Vollautomat', m_sieb: 'Siebträger', m_moka: 'Herdkanne',
      d_espresso: 'Espresso', d_cafe_creme: 'Café Crème', d_cappuccino: 'Cappuccino', d_flat_white: 'Flat White',
      d_latte_macchiato: 'Latte Macchiato', d_americano: 'Americano', d_moka: 'Mokka pur', d_moka_milk: 'Mokka mit Milch',
      r_coffee: 'Kaffee', r_cup: 'In der Tasse', r_time: 'Zeit', r_ratio: 'Übersetzung', r_grind: 'Mahlgrad', r_milk: 'Milch',
      r_water: 'Wasser', r_strength: 'Stärke', r_temp: 'Temperatur', r_amount: 'Menge', r_heat: 'Hitze',
      v_fine: 'fein (Espresso)', v_coarser: 'eine Stufe gröber', v_same: 'wie Standard', v_auto_grind: 'Schritt für Schritt feiner',
      v_moka_grind: 'fein, etwas gröber als Espresso', v_mid: 'mittel', v_strong: 'stark', v_xstrong: 'sehr stark', v_high: 'hoch',
      approx: 'ca. ',
      deliv_sieb: 'in {a}–{b} Sekunden', deliv_auto: 'in unter einer Minute', deliv_moka: 'in ca. 5 Minuten',
      range: 'ca. {n} Tassen',
      s_sieb_1: '{dose}' + NBSP + 'g frisch mahlen, verteilen und gerade tampen.',
      s_sieb_2_standard: 'Bezug starten und bei {yield}' + NBSP + 'g stoppen. Das dauert {a}–{b} Sekunden.',
      s_sieb_2_chill: 'Eine Stufe gröber mahlen, Bezug starten und bei {yield}' + NBSP + 'g stoppen, nach {a}–{b} Sekunden.',
      s_sieb_2_sport: 'Gleicher Mahlgrad, aber schon bei {yield}' + NBSP + 'g stoppen, nach {a}–{b} Sekunden.',
      s_milk_cappuccino: '{milk}' + NBSP + 'ml Milch auf ca. 60' + NBSP + '°C aufschäumen und auf den Espresso gießen.',
      s_milk_flat_white: '{milk}' + NBSP + 'ml Milch feinporig aufschäumen, kaum Schaum, und einlaufen lassen.',
      s_milk_latte_macchiato: '{milk}' + NBSP + 'ml Milch aufschäumen und ins Glas geben, dann den Espresso langsam drauf. So entstehen die Schichten.',
      s_water_americano: '{water}' + NBSP + 'ml heißes Wasser in die Tasse, dann den Espresso drauf. So bleibt die Crema oben.',
      s_auto_1: 'Bohnen rein, aber nur so viele, wie du in ein paar Tagen brauchst.',
      s_auto_2: 'Stärke auf {strength}, Temperatur auf {temp}.',
      s_auto_espresso: 'Espresso mit {amount}' + NBSP + 'ml beziehen.',
      s_auto_cafe_creme: 'Café Crème mit {amount}' + NBSP + 'ml beziehen, Mahlgrad eine Stufe gröber als für Espresso.',
      s_auto_cappuccino: 'Cappuccino: {amount}' + NBSP + 'ml Espresso, dazu ca. {milk}' + NBSP + 'ml Milchschaum.',
      s_auto_flat_white: 'Flat White: {amount}' + NBSP + 'ml Espresso, dazu ca. {milk}' + NBSP + 'ml feinporige Milch.',
      s_auto_latte_macchiato: 'Latte Macchiato: erst ca. {milk}' + NBSP + 'ml Milch, dann {amount}' + NBSP + 'ml Espresso.',
      s_moka_1: 'Unterteil mit heißem Wasser bis knapp unter das Ventil füllen, bei einer 3-Tassen-Kanne ca. 150' + NBSP + 'ml.',
      s_moka_2: 'Sieb mit ca. 15–17' + NBSP + 'g Kaffee füllen, glattstreichen, nicht andrücken.',
      s_moka_3: 'Zuschrauben und bei mittlerer Hitze auf den Herd, Deckel offen.',
      s_moka_4: 'Sobald es blubbert: runter vom Herd und den Boden kurz kalt abschrecken.',
      s_moka_4_sport: 'Ein paar Sekunden früher runter vom Herd, bevor es blubbert. Kürzer heißt kräftiger. Dann den Boden kurz kalt abschrecken.',
      s_moka_chill: 'Zum Schluss 1:1 mit heißem Wasser verlängern.',
      s_moka_milk: 'Mit {milk}' + NBSP + 'ml heißer Milch auffüllen. Heiß, nicht kochend.',
      tip_sieb: 'Schmeckt’s sauer, mahl feiner. Schmeckt’s bitter, mahl gröber.',
      tip_auto: 'Mahlgrad nur bei laufendem Mahlwerk verstellen, immer eine Stufe, und erst die zweite oder dritte Tasse probieren.',
      tip_moka: 'Nicht andrücken und nicht zu heiß: Sobald es blubbert, ist Schluss.',
      tip_dairy: 'Vollmilch wird am cremigsten.',
      tip_oat: 'Nimm Hafer in der Barista-Variante, der schäumt stabiler.'
    },
    en: {
      st_charging: 'Charging…', st_letgo: 'Don’t let go! Almost there.', st_full: 'Fully charged. Ready to brew.',
      st_again: 'Already full. Can’t go higher… or can it?', st_over: 'Overcharged! 150%. Okay, that was too much juice.', st_zap: 'Bzzzt.',
      hud: 'Charge {p}', hud_full: 'Fully charged',
      share_copied: 'Link copied.', share_fail: 'Here’s your link: {url}', share_text: 'My Supercharger build: {title}',
      m_auto: 'Bean-to-cup', m_sieb: 'Espresso machine', m_moka: 'Moka pot',
      d_espresso: 'Espresso', d_cafe_creme: 'Café Crème', d_cappuccino: 'Cappuccino', d_flat_white: 'Flat White',
      d_latte_macchiato: 'Latte Macchiato', d_americano: 'Americano', d_moka: 'Moka straight', d_moka_milk: 'Moka with milk',
      r_coffee: 'Coffee', r_cup: 'In the cup', r_time: 'Time', r_ratio: 'Ratio', r_grind: 'Grind', r_milk: 'Milk',
      r_water: 'Water', r_strength: 'Strength', r_temp: 'Temperature', r_amount: 'Amount', r_heat: 'Heat',
      v_fine: 'fine (espresso)', v_coarser: 'one step coarser', v_same: 'same as standard', v_auto_grind: 'finer, step by step',
      v_moka_grind: 'fine, a bit coarser than espresso', v_mid: 'medium', v_strong: 'strong', v_xstrong: 'extra strong', v_high: 'high',
      approx: 'approx. ',
      deliv_sieb: 'in {a}–{b} seconds', deliv_auto: 'in under a minute', deliv_moka: 'in about 5 minutes',
      range: 'about {n} cups',
      s_sieb_1: 'Grind {dose}' + NBSP + 'g fresh, distribute and tamp level.',
      s_sieb_2_standard: 'Start the shot and stop at {yield}' + NBSP + 'g. That takes {a}–{b} seconds.',
      s_sieb_2_chill: 'Grind one step coarser, start the shot and stop at {yield}' + NBSP + 'g, after {a}–{b} seconds.',
      s_sieb_2_sport: 'Same grind, but stop early at {yield}' + NBSP + 'g, after {a}–{b} seconds.',
      s_milk_cappuccino: 'Steam {milk}' + NBSP + 'ml of milk to about 60' + NBSP + '°C and pour it over the espresso.',
      s_milk_flat_white: 'Steam {milk}' + NBSP + 'ml of milk into silky microfoam, barely any foam, and pour.',
      s_milk_latte_macchiato: 'Steam {milk}' + NBSP + 'ml of milk and pour it into the glass, then add the espresso slowly. That’s how you get the layers.',
      s_water_americano: 'Put {water}' + NBSP + 'ml of hot water in the cup, then the espresso on top. That keeps the crema up.',
      s_auto_1: 'Fill in beans, but only as many as you’ll use in a few days.',
      s_auto_2: 'Set strength to {strength} and temperature to {temp}.',
      s_auto_espresso: 'Pull an espresso with {amount}' + NBSP + 'ml.',
      s_auto_cafe_creme: 'Pull a café crème with {amount}' + NBSP + 'ml, grinder one step coarser than for espresso.',
      s_auto_cappuccino: 'Cappuccino: {amount}' + NBSP + 'ml of espresso plus about {milk}' + NBSP + 'ml of milk foam.',
      s_auto_flat_white: 'Flat white: {amount}' + NBSP + 'ml of espresso plus about {milk}' + NBSP + 'ml of silky milk.',
      s_auto_latte_macchiato: 'Latte macchiato: about {milk}' + NBSP + 'ml of milk first, then {amount}' + NBSP + 'ml of espresso.',
      s_moka_1: 'Fill the base with hot water to just below the valve, about 150' + NBSP + 'ml for a 3-cup pot.',
      s_moka_2: 'Fill the basket with about 15–17' + NBSP + 'g of coffee, level it, don’t tamp.',
      s_moka_3: 'Screw it together and put it on medium heat, lid open.',
      s_moka_4: 'As soon as it gurgles: off the heat and cool the base under cold water.',
      s_moka_4_sport: 'Take it off the heat a few seconds earlier, before it gurgles. Shorter means bolder. Then cool the base under cold water.',
      s_moka_chill: 'Finally, top it up 1:1 with hot water.',
      s_moka_milk: 'Top up with {milk}' + NBSP + 'ml of hot milk. Hot, not boiling.',
      tip_sieb: 'Tastes sour? Grind finer. Tastes bitter? Grind coarser.',
      tip_auto: 'Only change the grind while the grinder is running, one step at a time, and taste the second or third cup.',
      tip_moka: 'Don’t tamp, don’t overheat: once it gurgles, you’re done.',
      tip_dairy: 'Whole milk gets the creamiest.',
      tip_oat: 'Go for a barista oat drink, it foams more steadily.'
    }
  };

  var COUNTRY_EN = {
    'Indien': 'India', 'Brasilien': 'Brazil', 'Kolumbien': 'Colombia', 'Äthiopien': 'Ethiopia', 'Kenia': 'Kenya', 'Ruanda': 'Rwanda',
    'Burundi': 'Burundi', 'Tansania': 'Tanzania', 'Uganda': 'Uganda', 'Honduras': 'Honduras', 'Guatemala': 'Guatemala',
    'Costa Rica': 'Costa Rica', 'Nicaragua': 'Nicaragua', 'El Salvador': 'El Salvador', 'Mexiko': 'Mexico', 'Peru': 'Peru',
    'Bolivien': 'Bolivia', 'Ecuador': 'Ecuador', 'Panama': 'Panama', 'Indonesien': 'Indonesia', 'Papua-Neuguinea': 'Papua New Guinea',
    'Jemen': 'Yemen', 'Vietnam': 'Vietnam', 'China': 'China', 'Kongo': 'Congo', 'Malawi': 'Malawi', 'Sambia': 'Zambia',
    'Simbabwe': 'Zimbabwe', 'Thailand': 'Thailand', 'Myanmar': 'Myanmar', 'Kuba': 'Cuba', 'Jamaika': 'Jamaica',
    'Dominikanische Republik': 'Dominican Republic', 'Haiti': 'Haiti', 'Venezuela': 'Venezuela', 'Kamerun': 'Cameroon', 'Madagaskar': 'Madagascar'
  };

  var DRINKS = {
    auto: ['espresso', 'cafe_creme', 'cappuccino', 'flat_white', 'latte_macchiato'],
    sieb: ['espresso', 'cappuccino', 'flat_white', 'latte_macchiato', 'americano'],
    moka: ['moka', 'moka_milk']
  };
  var MILK_DRINKS = { cappuccino: 1, flat_white: 1, latte_macchiato: 1, moka_milk: 1 };
  var MODES = ['chill', 'standard', 'sport'];
  var MODE_NAME = { chill: 'Chill', standard: 'Standard', sport: 'Sport' };
  var VIS = {
    espresso: ['espresso', [['coffee', 56]]],
    cafe_creme: ['cup', [['coffee', 72]]],
    cappuccino: ['cup', [['coffee', 24], ['mixmilk', 38], ['foam', 24]]],
    flat_white: ['cups', [['coffee', 26], ['mixmilk', 54], ['foam', 7]]],
    latte_macchiato: ['glass', [['milk', 46], ['coffee', 14], ['foam', 28]]],
    americano: ['mug', [['long', 76]]],
    moka: ['espresso', [['coffee', 56]]],
    moka_milk: ['cup', [['mix', 78]]]
  };

  /* ---------- Helfer ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function num(s) { var n = parseFloat(String(s == null ? '' : s).replace(',', '.')); return isNaN(n) ? null : n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(str, vars) { return String(str).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; }); }
  function fmtNum(n, lang) {
    var r = Math.round(n * 10) / 10;
    var s = (r % 1 === 0) ? String(Math.round(r)) : r.toFixed(1);
    return lang === 'de' ? s.replace('.', ',') : s;
  }
  function fmtPct(p, lang) { return lang === 'de' ? (p + NBSP + '%') : (p + '%'); }
  function altitude(raw, lang) {
    if (!raw) return '';
    var m = String(raw).match(/(\d[\d.,]*)\s*(?:-|–|bis)\s*(\d[\d.,]*)/);
    var toN = function (x) { return parseInt(String(x).replace(/[.,]/g, ''), 10); };
    var fmt = function (n) { return lang === 'de' ? n.toLocaleString('de-DE') : n.toLocaleString('en-US'); };
    var unit = lang === 'de' ? ' m ü. NN' : ' m a.s.l.';
    if (m) return fmt(toN(m[1])) + '–' + fmt(toN(m[2])) + unit;
    var one = String(raw).match(/(\d[\d.,]*)/);
    return one ? fmt(toN(one[1])) + unit : String(raw);
  }
  function vibrate(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }

  /* ---------- Instanz ---------- */
  function init(root) {
    if (!root || root.getAttribute('data-sc-init') === '1') return;
    root.setAttribute('data-sc-init', '1');
    var data = {};
    try { data = JSON.parse(($('[data-sc-data]', root) || {}).textContent || '{}'); } catch (e) { data = {}; }
    var R = data.recipe || {};
    var D = {
      dose: num(R.dose) || 19,
      ratio: num(R.ratio) || 2.5,
      tmin: num(R.tmin) || 30,
      tmax: num(R.tmax) || 35
    };
    if (D.tmax < D.tmin) D.tmax = D.tmin + 5;
    D.yield = num(R.yield) || Math.round(D.dose * D.ratio * 10) / 10;

    var state = { lang: 'de', level: 0 };
    var listeners = [];
    function onLang(fn) { listeners.push(fn); }
    function t(key, vars) { var v = T[state.lang][key]; return v == null ? key : fill(v, vars); }

    /* ----- i18n ----- */
    var enDict = {};
    Object.keys(EN).forEach(function (k) { enDict[k] = EN[k]; });
    var extra = data.en || {};
    Object.keys(extra).forEach(function (k) { if (extra[k]) enDict[k] = extra[k]; });
    var frontC = (data.front && data.front.country) || '';
    var rearC = (data.rear && data.rear.country) || '';
    var enVars = {
      dose: esc(fmtNum(D.dose, 'en')), yield: esc(fmtNum(D.yield, 'en')),
      front: esc(COUNTRY_EN[frontC] || frontC), rear: esc(COUNTRY_EN[rearC] || rearC)
    };
    var txt = $$('[data-i18n]', root).map(function (el) { return { el: el, k: el.getAttribute('data-i18n'), de: el.textContent }; });
    var htm = $$('[data-i18n-html]', root).map(function (el) { return { el: el, k: el.getAttribute('data-i18n-html'), de: el.innerHTML }; });
    var atr = $$('[data-i18n-attr]', root).map(function (el) {
      var p = (el.getAttribute('data-i18n-attr') || '').split(':');
      return { el: el, a: p[0], k: p[1], de: el.getAttribute(p[0]) };
    });
    var vals = $$('[data-sc-val]', root).map(function (el) { return { el: el, k: el.getAttribute('data-sc-val'), de: el.textContent }; });
    var fmts = $$('[data-sc-fmt]', root).map(function (el) { return { el: el, k: el.getAttribute('data-sc-fmt'), de: el.textContent }; });
    [txt, htm, atr, vals, fmts].forEach(function (list) { list.forEach(function (n) { n.el.setAttribute('data-wg-notranslate', ''); }); });

    function applyLang(lang) {
      var en = lang === 'en';
      txt.forEach(function (n) { var v = en ? enDict[n.k] : n.de; if (v != null) n.el.textContent = en ? fill(v, enVars).replace(/&amp;/g, '&') : v; });
      htm.forEach(function (n) { var v = en ? enDict[n.k] : n.de; if (v != null) n.el.innerHTML = en ? fill(v, enVars) : v; });
      atr.forEach(function (n) { var v = en ? enDict[n.k] : n.de; if (v != null) n.el.setAttribute(n.a, v); });
      vals.forEach(function (n) {
        if (!en) { n.el.textContent = n.de; return; }
        var side = n.k.split('.')[0], field = n.k.split('.')[1];
        var src = data[side] || {};
        if (field === 'country') n.el.textContent = COUNTRY_EN[src.country] || src.country || n.de;
        else if (field === 'altitude') n.el.textContent = altitude(src.altitude, 'en') || n.de;
      });
      fmts.forEach(function (n) { if (n.k === 'ratio') n.el.textContent = fmtNum(D.ratio, lang); });
      root.setAttribute('lang', lang);
      $$('[data-sc-lang]', root).forEach(function (b) {
        var on = b.getAttribute('data-sc-lang') === lang;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function setLang(lang, fromWeglot) {
      if (lang !== 'de' && lang !== 'en') return;
      var changed = lang !== state.lang;
      state.lang = lang;
      applyLang(lang);
      if (changed) listeners.forEach(function (fn) { fn(lang); });
      if (!fromWeglot) {
        try {
          var W = window.Weglot;
          if (W && W.initialized && typeof W.getCurrentLang === 'function' && W.getCurrentLang() !== lang) W.switchTo(lang);
        } catch (e) {}
      }
    }
    $$('[data-sc-lang]', root).forEach(function (b) {
      b.addEventListener('click', function () { setLang(b.getAttribute('data-sc-lang')); });
    });

    /* ----- Hero ----- */
    var hero = $('[data-sc-hero]', root);
    /* Abstand zum Seitenanfang (Theme-Header, Ankündigungsleiste), damit der Hero auf dem Desktop genau in den ersten Bildschirm passt. */
    function setTop() {
      if (!hero) return;
      var top = hero.getBoundingClientRect().top + (window.pageYOffset || 0);
      root.style.setProperty('--sc-top', Math.round(clamp(top, 0, 340)) + 'px');
    }
    setTop();
    var topTimer = 0;
    window.addEventListener('resize', function () { clearTimeout(topTimer); topTimer = setTimeout(setTop, 150); });
    window.addEventListener('load', setTop);
    var stage = $('[data-sc-stage]', root);
    var canvas = $('[data-sc-canvas]', root);
    var beanWrap = $('[data-sc-bean-wrap]', root);
    var btn = $('[data-sc-charge]', root);
    var ring = $('.sc-ring-bar', root);
    var pctEl = $('[data-sc-pct]', root);
    var statusEl = $('[data-sc-status]', root);
    var flashEl = $('[data-sc-flash]', root);
    var g = canvas && canvas.getContext ? canvas.getContext('2d') : null;

    var REG = { x: 494.6, y: 102.4, w: 1483.8, h: 1152 };
    var BEAN = { x: 1259.2, y: 840.1, a: 194.9, b: 255.3, rot: 24.34 * Math.PI / 180 };
    var PAD = { x: 1235, y: 1133, rx: 125, ry: 29, rx2: 736, ry2: 118 };
    var TIP = { x: 1236, y: 520 };
    var CW = 0, CH = 0, k = 1, lw = 1;
    var level = 0, charging = false, auto = false, full = false, over = 0, pressT = 0;
    var bolts = [], ripples = [], sparks = [], acc = 0, racc = 0, sacc = 0;
    var heroVisible = true, running = false, last = 0, t0 = performance.now(), lastShown = -1;
    var beanOff = { x: 0, y: 0 };

    function resize() {
      if (!canvas || !g) return;
      var r = canvas.getBoundingClientRect();
      CW = r.width; CH = r.height;
      if (!CW || !CH) return;
      k = CW / REG.w;
      var dpr = window.devicePixelRatio || 1;
      var s = clamp(Math.min(dpr, Math.sqrt(1400000 / (CW * CH))), 0.7, 2);
      canvas.width = Math.round(CW * s); canvas.height = Math.round(CH * s);
      g.setTransform(s, 0, 0, s, 0, 0);
      lw = clamp(CW / 620, 0.55, 1.5);
    }
    function P(x, y) { return [(x - REG.x) * k, (y - REG.y) * k]; }
    function beanPt(tt, grow) {
      var c = Math.cos(BEAN.rot), s = Math.sin(BEAN.rot), gr = grow || 1;
      var ex = Math.cos(tt) * BEAN.a * gr, ey = Math.sin(tt) * BEAN.b * gr;
      var p = P(BEAN.x + ex * c - ey * s, BEAN.y + ex * s + ey * c);
      return [p[0] + beanOff.x, p[1] + beanOff.y];
    }
    function makeBolt(a, b, rough, depth) {
      var pts = [a, b], disp = Math.hypot(b[0] - a[0], b[1] - a[1]) * rough;
      for (var it = 0; it < 6 && disp > 0.8; it++) {
        var np = [pts[0]];
        for (var i = 0; i < pts.length - 1; i++) {
          var p = pts[i], q = pts[i + 1];
          var dx = q[0] - p[0], dy = q[1] - p[1], len = Math.hypot(dx, dy) || 1;
          var off = (Math.random() * 2 - 1) * disp;
          np.push([(p[0] + q[0]) / 2 - dy / len * off, (p[1] + q[1]) / 2 + dx / len * off], q);
        }
        pts = np; disp *= 0.52;
      }
      var bolt = { pts: pts, br: [] };
      if (!depth) {
        var nb = Math.random() < 0.55 ? 1 + (Math.random() < 0.35 ? 1 : 0) : 0;
        for (var j = 0; j < nb; j++) {
          var idx = Math.floor(rnd(0.25, 0.75) * (pts.length - 1)), s0 = pts[idx];
          var ang = Math.atan2(b[1] - a[1], b[0] - a[0]) + rnd(-0.9, 0.9);
          var L = Math.hypot(b[0] - a[0], b[1] - a[1]) * rnd(0.2, 0.45);
          bolt.br.push(makeBolt(s0, [s0[0] + Math.cos(ang) * L, s0[1] + Math.sin(ang) * L], 0.3, 1).pts);
        }
      }
      return bolt;
    }
    function spawnBolt(kind) {
      var a, b, rough = 0.2, r = Math.random();
      kind = kind || (over > 0 ? 'storm' : (r < 0.42 ? 'pad' : r < 0.58 ? 'tip' : 'crack'));
      if (kind === 'pad') {
        var ph = rnd(Math.PI * 1.05, Math.PI * 1.95), sc = rnd(0.6, 1.7);
        a = P(PAD.x + Math.cos(ph) * PAD.rx * sc, PAD.y + Math.sin(ph) * PAD.ry * sc);
        b = beanPt(rnd(Math.PI * 0.18, Math.PI * 0.82));
      } else if (kind === 'tip') {
        a = P(TIP.x + rnd(-14, 14), TIP.y + rnd(-6, 6));
        b = beanPt(rnd(Math.PI * 1.3, Math.PI * 1.7));
        rough = 0.16;
      } else if (kind === 'crack') {
        var tt = rnd(0, Math.PI * 2);
        a = beanPt(tt, 0.98);
        b = beanPt(tt + rnd(-0.35, 0.35), rnd(1.3, 1.95));
        rough = 0.3;
      } else {
        var t2 = rnd(0, Math.PI * 2);
        a = beanPt(t2, 0.98);
        b = [clamp(a[0] + Math.cos(t2) * rnd(CW * 0.25, CW * 0.6), 0, CW), clamp(a[1] + Math.sin(t2) * rnd(CH * 0.2, CH * 0.5), 0, CH)];
        rough = 0.24;
      }
      var bolt = makeBolt(a, b, rough, 0);
      bolt.life = bolt.max = rnd(0.1, 0.3) * (over > 0 ? 1.4 : 1);
      bolts.push(bolt);
      if (bolts.length > 90) bolts.shift();
    }
    function strokePath(pts, w, col) {
      g.beginPath(); g.moveTo(pts[0][0], pts[0][1]);
      for (var i = 1; i < pts.length; i++) g.lineTo(pts[i][0], pts[i][1]);
      g.lineWidth = w; g.strokeStyle = col; g.stroke();
    }
    function drawBolt(bo) {
      var a = Math.pow(clamp(bo.life / bo.max, 0, 1), 0.6) * rnd(0.65, 1);
      var all = [bo.pts].concat(bo.br);
      for (var i = 0; i < all.length; i++) {
        var m = i === 0 ? 1 : 0.55;
        strokePath(all[i], 12 * lw * m, 'rgba(255,40,30,' + (0.1 * a) + ')');
        strokePath(all[i], 4.4 * lw * m, 'rgba(255,80,60,' + (0.55 * a) + ')');
        strokePath(all[i], 1.8 * lw * m, 'rgba(255,246,240,' + (0.98 * a) + ')');
      }
    }
    function draw(dt) {
      if (!g || !CW) return;
      g.clearRect(0, 0, CW, CH);
      g.globalCompositeOperation = 'lighter';
      g.lineCap = 'round'; g.lineJoin = 'round';
      var pc = P(PAD.x, PAD.y);
      for (var i = ripples.length - 1; i >= 0; i--) {
        var rp = ripples[i]; rp.p += dt * rp.v;
        if (rp.p >= 1) { ripples.splice(i, 1); continue; }
        var e = 1 - Math.pow(1 - rp.p, 2);
        var rx = (PAD.rx + (PAD.rx2 - PAD.rx) * e) * k, ry = (PAD.ry + (PAD.ry2 - PAD.ry) * e) * k;
        var al = Math.pow(1 - rp.p, 1.6) * (0.35 + 0.65 * rp.s);
        g.beginPath(); g.ellipse(pc[0], pc[1], rx, ry, 0, 0, Math.PI * 2);
        g.lineWidth = 7 * lw; g.strokeStyle = 'rgba(255,40,40,' + (al * 0.28) + ')'; g.stroke();
        g.lineWidth = 2 * lw; g.strokeStyle = 'rgba(255,140,120,' + al + ')'; g.stroke();
      }
      for (var j = sparks.length - 1; j >= 0; j--) {
        var sp = sparks[j]; sp.life -= dt;
        if (sp.life <= 0) { sparks.splice(j, 1); continue; }
        sp.x += sp.vx * dt; sp.y += sp.vy * dt; sp.vy *= 0.985;
        g.beginPath(); g.arc(sp.x, sp.y, sp.r, 0, Math.PI * 2);
        g.fillStyle = 'rgba(255,' + (110 + Math.floor(sp.life * 80)) + ',90,' + clamp(sp.life / sp.max, 0, 1) + ')';
        g.fill();
      }
      for (var b = bolts.length - 1; b >= 0; b--) {
        var bo = bolts[b]; bo.life -= dt;
        if (bo.life <= 0) { bolts.splice(b, 1); continue; }
        drawBolt(bo);
      }
      g.globalCompositeOperation = 'source-over';
    }
    function addSpark() {
      var pc = P(PAD.x + rnd(-PAD.rx * 1.2, PAD.rx * 1.2), PAD.y + rnd(-PAD.ry, PAD.ry * 0.3));
      var life = rnd(0.5, 1.3);
      sparks.push({ x: pc[0], y: pc[1], vx: rnd(-18, 18) * lw, vy: -rnd(40, 150) * lw, r: rnd(0.7, 2.1) * lw, life: life, max: life });
      if (sparks.length > 160) sparks.shift();
    }
    function showLevel() {
      var p = Math.round(level * 100);
      if (ring) ring.style.strokeDashoffset = String(100 - level * 100);
      if (p !== lastShown) {
        lastShown = p;
        if (pctEl) pctEl.textContent = fmtPct(p, state.lang);
        state.level = p;
        updateBatt();
      }
    }
    function setStatus(key) { if (statusEl) { statusEl.setAttribute('data-k', key); statusEl.textContent = key ? t(key) : ''; } }
    function burst(n) { for (var i = 0; i < n; i++) spawnBolt(); for (var r = 0; r < 3; r++) ripples.push({ p: r * 0.18, v: 0.9, s: 1 }); }
    function onFull() {
      full = true; charging = false; auto = false; level = 1;
      hero.classList.add('is-full');
      btn.classList.remove('is-pressed');
      if (flashEl && !RM) { flashEl.classList.remove('is-on'); void flashEl.offsetWidth; flashEl.classList.add('is-on'); }
      if (!RM) burst(22);
      vibrate([25, 40, 70]);
      setStatus('st_full');
      if (RM && stage) stage.style.setProperty('--lvl', '1');
      showLevel();
    }
    function frame(now) {
      if (!root.isConnected) { running = false; return; }
      var dt = Math.min(0.05, last ? (now - last) / 1000 : 0.016); last = now;
      if (charging || auto) { level = Math.min(1, level + dt / 2.3); if (level >= 1 && !full) onFull(); }
      else if (!full && level > 0) level = Math.max(0, level - dt / 3.2);
      var vis = over > 0 ? 1 : level;
      stage.style.setProperty('--lvl', vis.toFixed(3));
      var fl = (charging || auto || over > 0) ? 0.78 + Math.random() * 0.22 : (full ? 0.9 + Math.random() * 0.1 : 1);
      stage.style.setProperty('--flick', fl.toFixed(3));
      showLevel();
      var tt = (now - t0) / 1000;
      var fy = Math.sin(tt * 1.7) * 3.2 * (1 - 0.4 * level) - level * 7, jx = 0, jy = 0, jr = 0;
      if (charging || auto || over > 0) {
        var jj = over > 0 ? 5 : level * 3.2;
        jx = (Math.random() - 0.5) * jj; jy = (Math.random() - 0.5) * jj; jr = (Math.random() - 0.5) * jj * 0.5;
      }
      beanOff.x = jx; beanOff.y = fy + jy;
      beanWrap.style.transform = 'translate3d(' + jx.toFixed(2) + 'px,' + (fy + jy).toFixed(2) + 'px,0) rotate(' + jr.toFixed(2) + 'deg) scale(' + (1 + level * 0.035).toFixed(4) + ')';
      var active = charging || auto;
      var rate = over > 0 ? 50 : active ? 6 + 40 * level : (full ? 3.5 : 1.4);
      acc += rate * dt; while (acc >= 1) { acc -= 1; spawnBolt(); }
      var rint = over > 0 ? 0.18 : active ? Math.max(0.3, 2.3 - 2 * level) : (full ? 1.5 : 2.4);
      racc += dt; if (racc >= rint) { racc = 0; ripples.push({ p: 0, v: active || over > 0 ? 1.1 : 0.62, s: over > 0 ? 1 : level }); }
      var srate = over > 0 ? 60 : active ? 8 + 36 * level : (full ? 10 : 5);
      sacc += srate * dt; while (sacc >= 1) { sacc -= 1; addSpark(); }
      draw(dt);
      if (over > 0) { over -= dt; if (over <= 0) { over = 0; stage.classList.remove('is-over'); } }
      if ((heroVisible && !document.hidden) || active) { requestAnimationFrame(frame); } else { running = false; }
    }
    function ensureLoop() {
      if (RM || running || !g) return;
      running = true; last = 0;
      requestAnimationFrame(frame);
    }
    function press() {
      if (full) { setStatus('st_again'); if (!RM) burst(6); return; }
      if (RM) { onFull(); return; }
      charging = true; auto = false; pressT = performance.now();
      btn.classList.add('is-pressed');
      setStatus('st_charging');
      ensureLoop();
    }
    function release() {
      if (!charging) return;
      charging = false;
      btn.classList.remove('is-pressed');
      if (full) return;
      if (performance.now() - pressT < 300) { auto = true; setStatus('st_charging'); ensureLoop(); }
      else setStatus('st_letgo');
    }
    var lastInput = 0;
    if (btn && stage && beanWrap) {
      btn.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        e.preventDefault();
        lastInput = performance.now();
        try { btn.setPointerCapture(e.pointerId); } catch (err) {}
        press();
      });
      btn.addEventListener('pointerup', function () { lastInput = performance.now(); release(); });
      btn.addEventListener('pointercancel', function () { lastInput = performance.now(); release(); });
      btn.addEventListener('lostpointercapture', release);
      btn.addEventListener('keydown', function (e) {
        if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); lastInput = performance.now(); press(); }
      });
      btn.addEventListener('keyup', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); lastInput = performance.now(); release(); }
      });
      btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        /* Screenreader und andere Hilfsmittel lösen oft nur „click“ aus: dann automatisch voll laden. */
        if (performance.now() - lastInput < 700) return;
        if (full) { setStatus('st_again'); return; }
        if (RM) { onFull(); return; }
        if (!charging && !auto) { auto = true; setStatus('st_charging'); ensureLoop(); }
      });

      var taps = [];
      beanWrap.addEventListener('click', function () {
        var now = performance.now();
        taps = taps.filter(function (x) { return now - x < 2200; }); taps.push(now);
        if (taps.length >= 5) {
          taps = [];
          if (!full) onFull();
          over = 2.2;
          if (!RM) { stage.classList.remove('is-over'); void stage.offsetWidth; stage.classList.add('is-over'); burst(30); }
          vibrate([60, 40, 60, 40, 140]);
          setStatus('st_over');
          ensureLoop();
        } else if (!RM) {
          for (var i = 0; i < 4; i++) spawnBolt('crack');
          ensureLoop();
        }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { heroVisible = en.isIntersecting; if (heroVisible) ensureLoop(); });
        }, { threshold: 0.02 }).observe(hero);
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden) ensureLoop(); });
      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
      else window.addEventListener('resize', resize);
      resize();
      ensureLoop();
    }
    onLang(function () {
      lastShown = -1; showLevel();
      var k2 = statusEl && statusEl.getAttribute('data-k');
      if (k2) statusEl.textContent = t(k2);
    });

    /* ----- Zähler ----- */
    var counted = false;
    var specs = $('[data-sc-specs]', root);
    function runCount() {
      if (counted) return; counted = true;
      if (RM) return;
      $$('[data-sc-count]', root).forEach(function (el) {
        var to = num(el.getAttribute('data-sc-count')); if (to == null) return;
        var st = performance.now(), dur = 1300;
        (function f(n) {
          var p = Math.min(1, (n - st) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = String(Math.round(to * e));
          if (p < 1) requestAnimationFrame(f);
        })(st);
      });
    }

    /* ----- Dual Motor ----- */
    var motorSec = $('[data-sc-motor-sec]', root);
    $$('[data-sc-mcard]', root).forEach(function (card) {
      var side = card.getAttribute('data-sc-mcard');
      var motor = $('.sc-ch-motor-' + (side === 'front' ? 'f' : 'r'), root);
      var on = function () { card.classList.add('is-hot'); if (motor) motor.classList.add('is-hot'); };
      var off = function () { card.classList.remove('is-hot'); if (motor) motor.classList.remove('is-hot'); };
      card.addEventListener('mouseenter', on); card.addEventListener('mouseleave', off);
      card.addEventListener('focusin', on); card.addEventListener('focusout', off);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          if (en.target === specs) runCount();
          if (en.target === motorSec) motorSec.classList.add('is-on');
          io.unobserve(en.target);
        });
      }, { threshold: 0.25 });
      if (specs) io.observe(specs);
      if (motorSec) io.observe(motorSec);
    } else { if (motorSec) motorSec.classList.add('is-on'); }

    /* ----- Flavour-Kacheln ----- */
    $$('[data-sc-tile]', root).forEach(function (tile) {
      tile.addEventListener('click', function () {
        var open = tile.getAttribute('aria-expanded') === 'true';
        tile.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    /* ----- Batterie (Display + HUD) ----- */
    var battFill = $('[data-sc-batt-fill]', root), battPct = $('[data-sc-batt-pct]', root);
    function updateBatt() {
      if (battFill) battFill.style.width = 'calc((100% - 3px) * ' + (state.level / 100).toFixed(2) + ')';
      if (battPct) battPct.textContent = fmtPct(state.level, state.lang);
    }
    var hud = $('[data-sc-hud]', root), hudFill = $('[data-sc-hud-fill]', root), hudText = $('[data-sc-hud-text]', root);
    var hudTick = false;
    function hudUpdate() {
      hudTick = false;
      if (!hud) return;
      var r = root.getBoundingClientRect(), vh = window.innerHeight || 800;
      var hr = hero.getBoundingClientRect();
      var prog = clamp((vh * 0.6 - r.top) / Math.max(1, r.height - vh * 0.4), 0, 1);
      var show = hr.bottom < vh * 0.15 && r.bottom > vh * 0.35;
      hud.classList.toggle('is-on', show);
      var p = Math.round(prog * 100), isFull = p >= 98;
      hud.classList.toggle('is-full', isFull);
      if (hudFill) hudFill.style.width = 'calc((100% - 3px) * ' + (isFull ? 1 : prog).toFixed(3) + ')';
      if (hudText) hudText.textContent = isFull ? t('hud_full') : t('hud', { p: fmtPct(p, state.lang) });
    }
    function hudReq() { if (!hudTick) { hudTick = true; requestAnimationFrame(hudUpdate); } }
    window.addEventListener('scroll', hudReq, { passive: true });
    window.addEventListener('resize', hudReq);
    onLang(function () { updateBatt(); hudUpdate(); });

    /* ----- Etikett-Tilt ----- */
    var tilt = $('[data-sc-tilt]', root);
    if (tilt && !RM && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      tilt.addEventListener('pointermove', function (e) {
        var r = tilt.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        tilt.style.transform = 'perspective(900px) rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 10).toFixed(2) + 'deg)';
      });
      tilt.addEventListener('pointerleave', function () { tilt.style.transform = ''; });
    }

    /* ----- Konfigurator ----- */
    var build = $('[data-sc-build]', root);
    var cfg = { machine: 'auto', drink: 'espresso', mode: 'standard', milk: 'dairy' };
    var drinkBox = $('[data-sc-opts="drink"]', root);
    var milkStep = $('[data-sc-milkstep]', root);
    var cup = $('[data-sc-cup]', root);
    var layers = cup ? $$('.sc-l', cup) : [];
    var outs = {};
    $$('[data-sc-out]', root).forEach(function (el) { outs[el.getAttribute('data-sc-out')] = el; });
    var summary = $('[data-sc-summary]', root);
    var shareBtn = $('[data-sc-share]', root), shareMsg = $('[data-sc-share-msg]', root);
    var uid = data.id || 'x';

    function renderDrinks() {
      if (!drinkBox) return;
      var list = DRINKS[cfg.machine];
      if (list.indexOf(cfg.drink) < 0) cfg.drink = list[0];
      drinkBox.innerHTML = '';
      list.forEach(function (d) {
        var lab = document.createElement('label'); lab.className = 'sc-opt';
        var inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'sc-drink-' + uid; inp.value = d; inp.checked = d === cfg.drink;
        var sp = document.createElement('span'); sp.className = 'sc-opt-in';
        var b = document.createElement('b'); b.textContent = t('d_' + d);
        sp.appendChild(b); lab.appendChild(inp); lab.appendChild(sp); drinkBox.appendChild(lab);
      });
    }
    function spec(label, value) { return [label, value]; }
    function compute() {
      var L = state.lang, m = cfg.machine, d = cfg.drink, mo = cfg.mode;
      var r = { specs: [], steps: [], tip: '', range: '', delivery: '' };
      var ml = { cappuccino: '120–150', flat_white: '100–120', latte_macchiato: '200–250', americano: '100–150', moka_milk: '100–150' };
      if (m === 'sieb') {
        var ratio = mo === 'chill' ? D.ratio + 0.5 : mo === 'sport' ? Math.max(1.5, D.ratio - 0.5) : D.ratio;
        var y = mo === 'standard' ? D.yield : D.dose * ratio;
        var a = mo === 'sport' ? Math.max(15, D.tmin - 5) : D.tmin, b = mo === 'sport' ? Math.max(20, D.tmax - 5) : D.tmax;
        var v = { dose: fmtNum(D.dose, L), yield: fmtNum(y, L), a: fmtNum(a, L), b: fmtNum(b, L) };
        r.specs.push(spec(t('r_coffee'), v.dose + NBSP + 'g'), spec(t('r_cup'), v.yield + NBSP + 'g'),
          spec(t('r_time'), v.a + '–' + v.b + NBSP + 's'), spec(t('r_ratio'), '1' + NBSP + ':' + NBSP + fmtNum(ratio, L)),
          spec(t('r_grind'), t(mo === 'chill' ? 'v_coarser' : mo === 'sport' ? 'v_same' : 'v_fine')));
        r.steps.push(t('s_sieb_1', v), t('s_sieb_2_' + mo, v));
        if (MILK_DRINKS[d]) { r.specs.push(spec(t('r_milk'), ml[d] + NBSP + 'ml')); r.steps.push(t('s_milk_' + d, { milk: ml[d] })); }
        if (d === 'americano') { r.specs.push(spec(t('r_water'), ml[d] + NBSP + 'ml')); r.steps.push(t('s_water_americano', { water: ml[d] })); }
        r.delivery = t('deliv_sieb', { a: v.a, b: v.b });
        r.range = t('range', { n: Math.floor(1000 / D.dose) });
        r.tip = t('tip_sieb');
      } else if (m === 'auto') {
        var str = mo === 'chill' ? t('v_mid') : mo === 'sport' ? t('v_xstrong') : t('v_strong');
        var temp = mo === 'chill' ? t('v_mid') : t('v_high');
        var amt = d === 'cafe_creme' ? '120–150' : (mo === 'sport' ? '25–30' : '40');
        r.specs.push(spec(t('r_strength'), str), spec(t('r_temp'), temp), spec(t('r_amount'), amt + NBSP + 'ml'),
          spec(t('r_grind'), d === 'cafe_creme' ? t('v_coarser') : t('v_auto_grind')));
        if (MILK_DRINKS[d]) r.specs.push(spec(t('r_milk'), t('approx') + ml[d] + NBSP + 'ml'));
        r.steps.push(t('s_auto_1'), t('s_auto_2', { strength: str, temp: temp }), t('s_auto_' + d, { amount: amt, milk: ml[d] || '' }));
        r.delivery = t('deliv_auto');
        r.range = t('range', { n: 100 });
        r.tip = t('tip_auto');
      } else {
        r.specs.push(spec(t('r_coffee'), '15–17' + NBSP + 'g'), spec(t('r_water'), t('approx') + '150' + NBSP + 'ml'),
          spec(t('r_grind'), t('v_moka_grind')), spec(t('r_heat'), t('v_mid')));
        if (d === 'moka_milk') r.specs.push(spec(t('r_milk'), ml.moka_milk + NBSP + 'ml'));
        r.steps.push(t('s_moka_1'), t('s_moka_2'), t('s_moka_3'), t(mo === 'sport' ? 's_moka_4_sport' : 's_moka_4'));
        if (mo === 'chill') r.steps.push(t('s_moka_chill'));
        if (d === 'moka_milk') r.steps.push(t('s_moka_milk', { milk: ml.moka_milk }));
        r.delivery = t('deliv_moka');
        r.range = t('range', { n: Math.floor(1000 / 16) });
        r.tip = t('tip_moka');
      }
      if (MILK_DRINKS[d] && m !== 'moka') r.tip += ' ' + t(cfg.milk === 'oat' ? 'tip_oat' : 'tip_dairy');
      r.name = 'Supercharger ' + t('d_' + d);
      r.title = r.name + ' · ' + MODE_NAME[mo];
      r.modeLine = t('m_' + m) + ' · ' + MODE_NAME[mo];
      return r;
    }
    function renderVisual() {
      if (!cup) return;
      var vis = VIS[cfg.drink] || VIS.espresso;
      cup.setAttribute('data-vessel', vis[0]);
      var f = cfg.mode === 'chill' ? 1.12 : cfg.mode === 'sport' ? 0.82 : 1;
      var bottom = 0;
      layers.forEach(function (el, i) {
        var L = vis[1][i];
        if (!L) { el.style.setProperty('--lh', '0%'); el.style.setProperty('--lb', bottom + '%'); el.removeAttribute('data-t'); return; }
        var h = L[1];
        if (L[0] === 'coffee' || L[0] === 'long') h = Math.min(90, h * (vis[1].length === 1 ? f : (f === 1 ? 1 : f > 1 ? 1.08 : 0.85)));
        el.setAttribute('data-t', L[0]);
        el.style.setProperty('--lb', bottom + '%');
        el.style.setProperty('--lh', h + '%');
        bottom += h;
      });
    }
    function renderSummary(pulse) {
      var r = compute();
      if (outs.name) outs.name.textContent = r.name;
      if (outs.modeName) outs.modeName.textContent = r.modeLine;
      if (outs.title) outs.title.textContent = r.title;
      if (outs.delivery) outs.delivery.textContent = r.delivery;
      if (outs.range) outs.range.textContent = r.range;
      if (outs.tip) outs.tip.textContent = r.tip;
      if (outs.specs) {
        outs.specs.innerHTML = '';
        r.specs.forEach(function (s) {
          var dv = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
          dt.textContent = s[0]; dd.textContent = s[1]; dv.appendChild(dt); dv.appendChild(dd); outs.specs.appendChild(dv);
        });
      }
      if (outs.steps) {
        outs.steps.innerHTML = '';
        r.steps.forEach(function (s) { var li = document.createElement('li'); li.textContent = s; outs.steps.appendChild(li); });
      }
      if (milkStep) milkStep.hidden = !(MILK_DRINKS[cfg.drink] && cfg.machine !== 'moka');
      renderVisual();
      if (pulse && summary && !RM) { summary.classList.remove('is-upd'); void summary.offsetWidth; summary.classList.add('is-upd'); }
      if (shareMsg) shareMsg.textContent = '';
    }
    function syncRadios() {
      ['machine', 'mode', 'milk'].forEach(function (key) {
        $$('[data-sc-opts="' + key + '"] input', root).forEach(function (inp) { inp.checked = inp.value === cfg[key]; });
      });
    }
    if (build) {
      build.addEventListener('change', function (e) {
        var inp = e.target;
        if (!inp || inp.type !== 'radio') return;
        var box = inp.closest('[data-sc-opts]'); if (!box) return;
        var key = box.getAttribute('data-sc-opts');
        cfg[key] = inp.value;
        if (key === 'machine') renderDrinks();
        renderSummary(true);
      });
      var qs = null;
      try { qs = new URLSearchParams(window.location.search); } catch (e) {}
      var preset = qs && qs.get('build');
      if (preset) {
        var p = preset.split('.');
        if (DRINKS[p[0]]) cfg.machine = p[0];
        if (p[1] && DRINKS[cfg.machine].indexOf(p[1]) > -1) cfg.drink = p[1];
        if (p[2] && MODES.indexOf(p[2]) > -1) cfg.mode = p[2];
        if (p[3] === 'oat' || p[3] === 'dairy') cfg.milk = p[3];
      }
      syncRadios(); renderDrinks(); renderSummary(false);
      if (preset) setTimeout(function () { try { build.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); } catch (e) {} }, 400);
      onLang(function () { renderDrinks(); renderSummary(false); });

      if (shareBtn) shareBtn.addEventListener('click', function () {
        var r = compute();
        var url = window.location.origin + window.location.pathname + '?build=' + [cfg.machine, cfg.drink, cfg.mode, cfg.milk].join('.') + (state.lang === 'en' ? '&lang=en' : '') + '#sc-build-' + uid;
        var text = t('share_text', { title: r.title });
        var done = function (key) { if (shareMsg) shareMsg.textContent = t(key, { url: url }); };
        if (navigator.share) {
          navigator.share({ title: 'Supercharger', text: text, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { done('share_copied'); }, function () { done('share_fail'); });
        } else { done('share_fail'); }
      });
    }

    /* ----- Sprache: Start + Weglot ----- */
    var startLang = 'de';
    try { var q = new URLSearchParams(window.location.search).get('lang'); if (q === 'en' || q === 'de') startLang = q; } catch (e) {}
    var docLang = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
    if (startLang === 'de' && docLang === 'en') startLang = 'en';
    setLang(startLang, true);
    var tries = 0;
    (function waitWeglot() {
      var W = window.Weglot;
      if (W && W.initialized) {
        try {
          var cur = W.getCurrentLang();
          if (cur === 'en' || cur === 'de') setLang(cur, true);
          if (typeof W.on === 'function') W.on('languageChanged', function (nl) { if (nl === 'en' || nl === 'de') setLang(nl, true); });
        } catch (e) {}
        return;
      }
      if (tries++ < 40) setTimeout(waitWeglot, 250);
    })();

    showLevel();
    hudUpdate();
  }

  function run(scope) { $$('[data-sc-root]', scope || document).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
